module.exports = __webpack_public_path__ + "media/25.ec9a604d.wav";